export default (ref, position = 0) => {
    return ref.current && window.scrollTo(position, ref.current.offsetTop);
};
